import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

// Injects analytics / tracking snippets configured in admin Settings
export const Analytics = () => {
  const { settings } = useSite();
  useEffect(() => {
    if (!settings) return;
    const added = [];
    const ga = settings.ga_measurement_id;
    const gtm = settings.gtm_id;
    const pixel = settings.facebook_pixel_id;

    if (ga) {
      const s1 = document.createElement("script");
      s1.async = true; s1.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
      document.head.appendChild(s1); added.push(s1);
      const s2 = document.createElement("script");
      s2.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga}');`;
      document.head.appendChild(s2); added.push(s2);
    }
    if (gtm) {
      const s = document.createElement("script");
      s.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtm}');`;
      document.head.appendChild(s); added.push(s);
    }
    if (pixel) {
      const s = document.createElement("script");
      s.text = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${pixel}');fbq('track','PageView');`;
      document.head.appendChild(s); added.push(s);
    }
    if (settings.head_scripts) {
      const wrap = document.createElement("div");
      wrap.innerHTML = settings.head_scripts;
      Array.from(wrap.querySelectorAll("script")).forEach((old) => {
        const sc = document.createElement("script");
        if (old.src) sc.src = old.src; else sc.text = old.text;
        document.head.appendChild(sc); added.push(sc);
      });
    }
    return () => { added.forEach((el) => el.remove()); };
  }, [settings]);
  return null;
};
